module.exports = __webpack_public_path__ + "img/simulatorProjectWhite.40702f59.svg";